// Where to send the user after they sign in: the page they pressed Login on
// (e.g. the sticker they were watching). Kept in localStorage because the
// sign-in can leave the page; expires so an abandoned login cannot redirect
// a later one.
export const LOGIN_RETURN_KEY = 'loginReturnTo';
const MAX_AGE_MS = 30 * 60 * 1000;
const AUTH_PATHS = ['/login', '/login/email', '/login/email/forgot', '/register', '/profile-info'];

// Same-site paths only ("/x", never "//host" or "https://..."), never an auth page.
export function isReturnablePath(path: any): boolean {
  if (typeof path !== 'string' || !path.startsWith('/') || path.startsWith('//')) return false;
  const pathname = path.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
  return pathname !== '/' && !AUTH_PATHS.includes(pathname);
}

export function saveLoginReturnPath(path: string, now: number = Date.now()): void {
  try {
    if (isReturnablePath(path)) localStorage.setItem(LOGIN_RETURN_KEY, JSON.stringify({ path, at: now }));
    else localStorage.removeItem(LOGIN_RETURN_KEY);
  } catch (e) {
    // storage blocked: after sign-in the user lands on the home page
  }
}

// Reads and forgets the saved path; null when missing, stale or invalid.
export function takeLoginReturnPath(now: number = Date.now()): string | null {
  try {
    const raw = localStorage.getItem(LOGIN_RETURN_KEY);
    localStorage.removeItem(LOGIN_RETURN_KEY);
    if (!raw) return null;
    const { path, at } = JSON.parse(raw);
    if (!isReturnablePath(path) || typeof at !== 'number' || now - at > MAX_AGE_MS || now < at) return null;
    return path;
  } catch (e) {
    return null;
  }
}
